import React from "react";
import { ScenarioElementPlaybackState } from "../../../../uiModel/playback/ScenarioElementPlaybackState";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { PauseIconComponent } from "../../../icons/playback/PauseIconComponent";
import { PlayIconComponent } from "../../../icons/playback/PlayIconComponent";
import { ReplayIconComponent } from "../../../icons/playback/ReplayIconComponent";
import { MenuButtonComponent } from "../common/MenuButtonComponent";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";

interface Props {
  playbackState: ScenarioElementPlaybackState;
  onPlay: () => void;
  onPause: () => void;
  onReplay: () => void;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
  className?: string;
}

export const PlaybackControlComponent: React.SFC<Props> = ({
  playbackState,
  onPlay,
  onPause,
  onReplay,
  onCancelTooltip,
  onRequestTooltip,
  className }) => {

  if (playbackState === "elementFinished") {
    return (
      <MenuButtonWithTooltipComponent
        isDisabled={true}
        icon={<PlayIconComponent />}
        onClick={() => {}}
        className={className}
        tooltipTarget="playbackControl"
        onCancelTooltip={onCancelTooltip}
        onRequestTooltip={onRequestTooltip}
      />);
  }

  let icon: React.ReactNode;
  let onClick: () => void;

  switch (playbackState) {
    case "scenarioFinished":
      icon = <ReplayIconComponent />;
      onClick = onReplay;
      break;
    case "paused":
    case "seekingAfterPause":
      icon = <PlayIconComponent />;
      onClick = onPlay;
      break;
    case "playing":
    case "seekingAfterPlay":
      icon = <PauseIconComponent />;
      onClick = onPause;
      break;
    default:
      throw new Error(`Unrecognized playbackState '${playbackState}'`);

  }
  return (
    <MenuButtonWithTooltipComponent
      icon={icon}
      onClick={onClick}
      className={className}
      tooltipTarget="playbackControl"
      onCancelTooltip={onCancelTooltip}
      onRequestTooltip={onRequestTooltip}
    />
  );
};
